module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOBAMAAADtZjDiAAAALVBMVEUAAAC7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7u7vj5ea/v7/q7O7FxcZ1sdFJAAAACnRSTlMA8oQUU/nR085UaCayRAAAAFdJREFUCNdjYGBWC00yYGBgcFy1apUIAwPLKhBwYDBc9WbVuVXCDFrrbp/Z+2oRQ9aavbtvn1rGELXq9N09q5ZC6YUwcZg6mD64OQwTIeYyMKsHNhkwAAAOgjMET8JSIQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./components/Icon/images/icon_clear_hover.png
// module id = hGSu
// module chunks = 9